import findResult from '@/utils/resultsHelper';
import { pagingWithResults } from '@/constants/states';
import { readStates } from '@/constants/lifecycle';

const subscribersResults = (code, event) => ({
  code,
  name: null,
  event,
  ...pagingWithResults(),
  ...readStates,
  filter: '',
  role: '',
});

export const findSubscriber = ({ subscribers }, { category, code }) => findResult(subscribers, category, code);

export const newSubscribersList = (code, event) => ({ ...subscribersResults(code, event) });

const subscribersResult = (result) => ({ code: result.uuid, ...result });

export default subscribersResult;
